module.exports = __webpack_public_path__ + "img/a1.02fa94d1.png";